import { MiButton } from "@miplatform/components";
import { BUTTON_VARIANTS, ICONS_WEB } from "@miplatform/constants";
import * as mdi from "@mdi/js";
import { Typography } from "@mui/material";

export function CircleQuantityControl({
  isDecreaseDisabled,
  isIncreaseDisabled,
  onDecreaseQty,
  onIncreaseQty,
  quantity,
}) {
  return (
    <>
      <MiButton
        variant={BUTTON_VARIANTS.CONTAINED}
        startIcon={{ path: mdi[ICONS_WEB.MINUS], iconSize: 0.5 }}
        disabled={isDecreaseDisabled}
        sx={{
          borderRadius: "50%",
          height: 20,
          width: 20,
          padding: 0,
        }}
        onClick={onDecreaseQty}
      />
      <Typography>{quantity}</Typography>
      <MiButton
        variant={BUTTON_VARIANTS.CONTAINED}
        startIcon={{ path: mdi[ICONS_WEB.PLUS], iconSize: 0.5 }}
        disabled={isIncreaseDisabled}
        sx={{
          borderRadius: "50%",
          height: 20,
          width: 20,
          padding: 0,
        }}
        onClick={onIncreaseQty}
      />
    </>
  );
}
